import ReportHeader from "./EnsaHeader";
import CardProfile from "./EnsaCardProfile";
import EnsaCard from "./EnsaCard";
import EnsaCard2 from "./EnsaCard2";
import EnsaCardPageBreak from "./EnsaCardPageBreak";
import ChartLabel from "./EnsaChartLabel";
import LabelChartProgresLiterasi from "./LabelChartProgresLiterasi";
import LabelChartKeteranganProgLit from "./LabelChartKeteranganProgLit";
import TableLiterasiSiswaPotensi from "./TableLiterasiSiswaPotensi"
import ChartP3 from "./ChartP3";
import ChartKesenjanganGenderSk from "./ChartKesenjanganGenderSk";
import ChartSkGender from "./ChartSkGender";
import ChartSLBGender from "./ChartSLBGender";
import ChartSLBGEkonomi from "./ChartSLBGEkonomi";
import LabelResumeKomparasi from "./LabelResumeKomparasi";
import TableKomparasiSekolah from "./TableKomparasiSekolah";

export { ReportHeader, 
    EnsaCard, 
    CardProfile, 
    ChartLabel, 
    LabelChartProgresLiterasi, 
    LabelChartKeteranganProgLit, 
    TableLiterasiSiswaPotensi, 
    ChartP3, 
    EnsaCard2, 
    EnsaCardPageBreak,
    ChartKesenjanganGenderSk,
    ChartSkGender,
    ChartSLBGender,
    ChartSLBGEkonomi,
    LabelResumeKomparasi,
    TableKomparasiSekolah,
 };
